import axios from 'axios';
import { redirectToLogin } from '../utils/sessionRedirect';

axios.defaults.headers.post['Content-Type'] = 'application/json';

const handleUnauthorizedSession = (): void => {
  if (!localStorage.getItem('gov_access_token')) {
    return;
  }
  redirectToLogin(window.location.pathname);
};

const attachUnauthorizedInterceptor = (instance: ReturnType<typeof axios.create>): void => {
  instance.interceptors.response.use(
    response => response,
    error => {
      if (error?.response?.status === 401) {
        handleUnauthorizedSession();
      }
      return Promise.reject(error);
    },
  );
};

const apisso = axios.create({
  baseURL: (window as any)._env_.REACT_APP_API_SSO ?? '',
});

const ssoSecondary = axios.create({
  baseURL: (window as any)._env_.REACT_APP_SSO_MTI ?? '',
});

const apisiseci = axios.create({
  baseURL: (window as any)._env_.REACT_APP_API_SISECI ?? '',
});

const apinewforms = axios.create({
  baseURL: (window as any)._env_.REACT_APP_API_NEWFORMS ?? '',
});

apisiseci.defaults.headers.common.Authorization = (window as any)._env_.REACT_APP_API_SISECI_KEY ?? '';
apisso.defaults.headers.common.Authorization = (window as any)._env_.REACT_APP_API_SSO_KEY ?? '';
apinewforms.defaults.headers.common.Authorization = (window as any)._env_.REACT_APP_API_FORMS_KEY ?? '';

attachUnauthorizedInterceptor(apisso);
attachUnauthorizedInterceptor(apisiseci);
attachUnauthorizedInterceptor(apinewforms);


export { apisso, apisiseci, ssoSecondary, apinewforms };
